import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  LONG_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";
import { APVehicleVariant } from "../../types/Vehicles";

export const getVehicleVariant = (
  variantCode: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["vehicle-variant", variantCode],
    queryFn: (): Promise<APVehicleVariant> => {
      return fetchWithAuth<APVehicleVariant>("getVehicleVariant", variantCode);
    },
    enabled: isQueryEnabled(options),
    staleTime: LONG_STALE_TIME,
  });
};
